module.exports = __webpack_public_path__ + "media/images/application/default-image-6498f882a3a3b136b881ea7ba7b106b8.jpg";